import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {
    result: false,
  },


  mutations: {

    setResult(state, result) {
      state.result = result
    },

  },

  actions: {
    async query({ commit }, orderId) {
      const data = await actionClient.post(`pay-result/${orderId}`)
      commit('setResult', data)
    }
  }


}
